import {
  branch, compose, pure, renderNothing, withProps,
} from 'recompose';

import BrillMask from './replyWrapper';
import { parseTextStyles } from '../../utils';

const enhance = compose(
  branch(({ children }) => !children, renderNothing),
  pure,
  withProps(({ children, messageId }) => ({
    content: parseTextStyles(children, messageId),
  })),
);
export default enhance(BrillMask);
